<template>
  <div class="container _container">
    <div class="containerbody">
      <div class="content">
        <div class="content_right">
          <el-card>
            <div slot="header" class="text_title">
              <span>{{ $t('home.search') || 'Search Results' }}</span>
            </div>

            <!-- Advanced Search Area -->
            <div class="advanced-search">
              <div class="search-form">
                <el-input
                  v-model="queryParams.title"
                  :placeholder="$t('home.placeholder') || 'Enter keyword'"
                  class="search-input">
                </el-input>
                <el-date-picker
                  v-model="queryParams.startTime"
                  type="date"
                  :placeholder="$t('home.startDate') || 'Start date'"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  class="date-picker">
                </el-date-picker>
                <el-date-picker
                  v-model="queryParams.endTime"
                  type="date"
                  :placeholder="$t('home.endDate') || 'End date'"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  class="date-picker">
                </el-date-picker>
                <el-button type="primary" @click="handleSearch" class="search-button">
                  {{ $t('home.search') || 'SEARCH' }}
                </el-button>
              </div>
            </div>

            <!-- Updated news list layout -->
            <div class="news-list">
              <div v-for="(item,index) in contentList" :key="index" class="news-item" @click="openDetail(item)">
                <div class="news-image">
                  <img v-if="item.Img" :src="$urlFile+item.Img" alt="News cover" />
                  <div v-else class="placeholder-image">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </div>
                <div class="news-content">
                  <h3 class="news-title">
                    <span class="text_type" v-if="item.className">[{{ item.className }}]</span>
                    {{ item.title }}
                  </h3>
                  <p class="news-summary">{{ item.zhaiYao || $t('home.noSummary') }}</p>
                  <div class="news-footer">
                    <span class="news-time">{{ item.time }}</span>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="total==0" class="no-data">{{ $t('home.noData') }}</div>

            <el-row style="text-align: center;margin-top: 10px">
              <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="queryParams.index"
                :page-sizes="[10, 20, 30, 50]"
                :page-size="queryParams.size"
                layout="total, sizes, prev, pager, next"
                :pager-count="4"
                :total="total">
              </el-pagination>
            </el-row>
          </el-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getContentList} from "@/api/navigation"
import cookie from "js-cookie";

export default {
  name: 'aboutUs',
  components: {
  },
  data() {
    return {
      imageUrl: require('@/components/aboutUs/imgs/facebook.png'),
      imageUrl2: require('@/components/aboutUs/imgs/Twitter.png'),
      total: 0,//总数
      activeIndex: 0,
      queryParams: {
        index: 1,
        size: 10,
        title: "",
        startTime: "",
        endTime: ""
      },
      titleTree: JSON.parse(sessionStorage.getItem('titleTree')),
      titleData: {},//标题内容
      titleDataChild: [{title: ""}],
      contentList: [],//内容展示列表,
      flag: false,
    }
  },
  created() {
    this.$watch('$route', () => {
      window.location.href = window.location.href
    });
  },
  mounted() {
    this.queryParams.title = this.$route.query.key,
    this.init()
  },
  methods: {
    init() {
      this.flag = false //是否为二级标题
      this.titleTree.children.forEach((item, index) => {
        if (item.data.id == this.id) {
          this.flag = true
        }
      });
      if (this.flag) {
        this.titleTree.children.forEach((item, index) => {
          if (item.data.id == this.id) {
            this.titleData = item
            this.titleDataChild = this.titleData.children
            this.queryParams.classId = item.children[0].data.id
            this.activeIndex = 0
          }
        });
        this.getData()
      } else {
        this.titleTree.children.forEach((item, index) => {
          if (item.data.id == this.pid) {
            this.titleData = item
            this.titleDataChild = this.titleData.children

            this.queryParams.classId = this.id
            item.children.forEach((item2, index2) => {
              if (item2.data.id == this.id) {
                this.activeIndex = index2

              }
            })
          }
        });
        this.getData()
      }
    },
    getPid(id){
      this.titleTree.children.forEach((item, index) => {
        if(item.children!=null&&item.children.length > 0){
          item.children.forEach((item2, index2) => {
            if (item2.data.id == id) {
              this.pid = item2.data.columnPid
            }
          })
        }

      });
    },
    handleSearch() {
      this.queryParams.index = 1
      this.getData()
    },
    getData() {
      if (this.$i18n.locale == 'zh') {
        this.queryParams.lang = "1"
      } else {
        this.queryParams.lang = "2"
      }
      getContentList(this.queryParams).then(res => {
        this.contentList = res.data
        this.total = res.count
      })
    },
    shareClick() {
      this.$refs.shareDialog.open('Repost to Facebook', {})

    },
    subTitleClick(index) {
      this.activeIndex = index
      this.queryParams.classId = this.titleData.children[index].data.id
      this.queryParams.index = 1
      this.queryParams.size = 10
      this.getData()
    },
    openDetail(item) {
      if (item.url != "") {
        window.open(item.url)
      } else {
        this.getPid(item.classId)
        this.$router.push({
          path: '/detail',
          query: {
            pid: this.pid,
            id: item.classId,
            detailId: item.id,
          }
        })
      }
    },
    /**页条数变化 */
    handleSizeChange(val) {
      this.queryParams.size = val
      this.queryParams.index = 1
      this.getData()
    },
    /**当前页变化 */
    handleCurrentChange(val) {
      this.queryParams.index = val
      this.getData()
    },
  }
}
</script>

<style lang="less" scoped>
// 大于800px
@media only screen and (min-width: 800px) {
  .container {
    width: 100%;
    overflow: hidden;

    .containerbody {
      width: 100%;
      min-height: 55.5vh;
      background-color: rgb(249, 249, 249);
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 20px 0;

      .content {
        width: 80%;
        margin: 0 auto;

        .content_right {
          width: 82%;
          margin: 0 auto;

          .text_title {
            width: 100%;
            text-align: left;
            font-family: SourceHanSansCN-Bold;
            font-weight: 700;
            color: rgba(51, 51, 51, 1);
            font-size: 16px;
          }

          .news-list {
            margin-bottom: 20px;
          }

          .news-item {
            display: flex;
            margin-bottom: 20px;
            padding-bottom: 20px;
            border-bottom: 1px solid #eaeaea;
            transition: all 0.3s ease;

            &:hover {
              transform: translateY(-3px);
              box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
            }

            &:last-child {
              margin-bottom: 0;
            }
          }

          .news-image {
            flex: 0 0 180px;
            height: 120px;
            margin-right: 20px;
            overflow: hidden;
            border-radius: 4px;
            background-color: #f5f7fa;
            border: 1px solid #eaeaea;

            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
              transition: transform 0.3s ease;

              &:hover {
                transform: scale(1.05);
              }
            }

            .placeholder-image {
              display: flex;
              align-items: center;
              justify-content: center;
              width: 100%;
              height: 100%;
              color: #c0c4cc;

              i {
                font-size: 40px;
              }
            }
          }

          .news-content {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
          }

          .news-title {
            margin: 0 0 10px;
            font-size: 18px;
            font-weight: 600;
            color: #333;
            line-height: 1.4;
            text-align: left;

            .text_type {
              color: #3a8ee6;
              margin-right: 5px;
            }
          }

          .news-summary {
            margin: 0 0 15px;
            font-size: 14px;
            color: #666;
            line-height: 1.6;
            text-align: left;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .news-footer {
            display: flex;
            justify-content: flex-start;
          }

          .news-time {
            font-size: 13px;
            color: #909399;
          }

          .no-data {
            padding: 30px 0;
            text-align: center;
            color: #CCCCCC;
            font-size: 14px;
            border-top: 1px solid #f0f0f0;
            margin-top: 20px;
          }
        }
      }
    }
  }
}

// 小于800px
@media only screen and (max-width: 800px) {
  .container {
    width: 100%;
  }

  .content_right {
    width: 95%;
    margin: 0 auto;
  }

  .news-list {
    margin-bottom: 15px;
  }

  .news-item {
    display: flex;
    margin-bottom: 15px;
    padding-bottom: 15px;
    border-bottom: 1px solid #eaeaea;
  }

  .news-image {
    flex: 0 0 100px;
    height: 80px;
    margin-right: 15px;
    overflow: hidden;
    border-radius: 4px;
    background-color: #f5f7fa;
    border: 1px solid #eaeaea;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .placeholder-image {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      color: #c0c4cc;

      i {
        font-size: 30px;
      }
    }
  }

  .news-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }

  .news-title {
    text-align: left;
    margin: 0 0 8px;
    font-size: 15px;
    font-weight: 600;
    color: #333;
    line-height: 1.4;

    .text_type {
      display: inline-block;
      color: #3a8ee6;
      margin-right: 5px;
    }
  }

  .news-summary {
    text-align: left;
    margin: 0 0 8px;
    font-size: 13px;
    color: #666;
    line-height: 1.5;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .news-footer {
    display: flex;
    justify-content: flex-start;
  }

  .news-time {
    font-size: 12px;
    color: #909399;
  }

  .no-data {
    padding: 20px 0;
    text-align: center;
    color: #CCCCCC;
    font-size: 14px;
    border-top: 1px solid #f0f0f0;
    margin-top: 15px;
  }

  /deep/.el-select {
    display: none;
  }

  /deep/.el-pagination span{
    min-width: 0;
  }

  /deep/.el-pagination__total {
    margin-right: 0;
  }
}

// Add these new styles for the advanced search area
.advanced-search {
  margin-bottom: 20px;
  padding: 15px;
  background-color: #f9f9f9;
  border-radius: 4px;

  .search-form {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;

    .search-input {
      flex: 1;
      min-width: 200px;
    }

    .date-picker {
      width: 160px;
    }

    .search-button {
      min-width: 100px;
    }
  }
}

// Media query for mobile devices
@media only screen and (max-width: 800px) {
  .advanced-search {
    .search-form {
      flex-direction: column;

      .search-input,
      .date-picker,
      .search-button {
        width: 100%;
        margin-bottom: 10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/page/search.vue